/* eslint-disable no-nested-ternary */

import React from 'react';
import { Alert } from 'reactstrap';
import PropTypes from 'prop-types';
var FormAlerts = function FormAlerts(_ref) {
  var _ref$errors = _ref.errors,
    errors = _ref$errors === undefined ? {} : _ref$errors,
    login = _ref.login,
    validationMessage = _ref.validationMessage,
    serverMessage = _ref.serverMessage,
    loginMessage = _ref.loginMessage;
  var validationErrors = Object.keys(errors).length ? !Object.keys(errors).includes('server') : undefined;
  var serverErrors = Object.keys(errors).length ? Object.keys(errors).includes('server') : undefined;
  return validationErrors || serverErrors ? React.createElement(Alert, {
    color: 'danger'
  }, validationErrors ? validationMessage : serverErrors ? login ? loginMessage : serverMessage : undefined) : null;
};
FormAlerts.propTypes = {
  login: PropTypes.bool,
  errors: PropTypes.shape().isRequired,
  validationMessage: PropTypes.string,
  serverMessage: PropTypes.string,
  loginMessage: PropTypes.string
};
FormAlerts.defaultProps = {
  login: false,
  validationMessage: 'Fill in required fields',
  serverMessage: 'We are unable to complete this action. Please contact your Cordata Support Representative.',
  loginMessage: 'Invalid Credentials'
};
export default FormAlerts;